import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

const AbsoluteAnchorComponent = props => {
    // dispatch prop is not used, but it's extracted here,
    // so that otherProps could be safely spread on the <a> elememt
    const { children, href, localeDomain, dispatch, dataTn, ...otherProps } = props; // eslint-disable-line no-unused-vars
    // If href is undefined or null, React will simply render an empty anchor element,
    // and if localeDomain is not set, it should render href as it is
    const absoluteUrl = localeDomain && href ? `https://${localeDomain}${href}` : href;

    return (
        <a href={absoluteUrl} data-tn={dataTn} {...otherProps}>
            {children}
        </a>
    );
};

AbsoluteAnchorComponent.propTypes = {
    localeDomain: PropTypes.string.isRequired,
    children: PropTypes.node,
    dataTn: PropTypes.string,
    href: PropTypes.string,
    dispatch: PropTypes.func,
};

const mapStateToProps = state => {
    const { intlVariables } = state;

    return { localeDomain: intlVariables.localeDomain };
};

export const AbsoluteAnchor = connect(mapStateToProps)(AbsoluteAnchorComponent);
